module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"headline":"Vertragsabschluss","start":"Beginn","end":"Ende","rules_end_date":"Enddatum muss nach dem %{startDate} liegen","rules_date_invalid":"Bitte gib ein valides Datum ein"},"en":{"headline":"Contract","start":"Start","end":"End","rules_end_date":"End date must be after %{startDate}","rules_date_invalid":"Please enter a valid date"}}')
  delete Component.options._Ctor
}
